<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="specialistMemberEdit" :model="formData" class="full-width-input" style="width: 100%;" :rules="rules"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
<!--        <el-col :span="24">-->
<!--          <el-form-item label="父表ID" prop="SpecialistMember.specialistId">-->
<!--            <el-input class="input-item" v-model="formData.SpecialistMember.specialistId"-->
<!--              :clearable="true" placeholder="父表ID"-->
<!--            />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="24">
          <el-form-item label="专家名称" prop="SpecialistMember.specialistName">
            <el-input class="input-item" v-model="formData.SpecialistMember.specialistName"
              :clearable="true" placeholder="专家名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="专家照片" prop="SpecialistMember.specialistAvatar">
            <el-upload
              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/specialistMember/upload')"
              :data="{fieldName: 'specialistAvatar', asImage: true}"
              :on-success="onSpecialistAvatarUploadSuccess"
              :on-remove="onSpecialistAvatarRemoveFile"
              :before-upload="pictureFile"
              :on-error="onUploadError"

              :show-file-list="false">
              <div v-if="specialistMemberEdit.specialistAvatar.impl.fileList && specialistMemberEdit.specialistAvatar.impl.fileList[0] != null" style="position: relative">
                <img class="upload-image-show"
                  :src="specialistMemberEdit.specialistAvatar.impl.fileList[0].url" />
                <div class="upload-img-del el-icon-close"
                  @click.stop="onSpecialistAvatarRemoveFile(null, null)" />
              </div>
              <i v-else class="el-icon-plus upload-image-item"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系电话" prop="SpecialistMember.mobilePhone">
            <el-input class="input-item" v-model="formData.SpecialistMember.mobilePhone"
              :clearable="true" placeholder="联系电话"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="产业" prop="SpecialistMember.industryId">
<!--            <el-select class="input-item" v-model="formData.SpecialistMember.industryId" :clearable="true" filterable-->
<!--              placeholder="产业" :loading="specialistMemberEdit.industryId.impl.loading"-->
<!--              @visible-change="specialistMemberEdit.industryId.impl.onVisibleChange"-->
<!--              @change="onIndustryIdValueChange">-->
<!--              <el-option v-for="item in specialistMemberEdit.industryId.impl.dropdownList" :key="item.id"-->
<!--                :value="item.id" :label="item.name"-->
<!--              />-->
<!--            </el-select>-->
            <el-cascader class="input-item"  v-model="formData.SpecialistMember.industryId" :options="specialistMemberEdit.industryId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="产业" ref="cascaderArr"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="specialistMemberEdit.industryId.impl.onVisibleChange"
                         @change="onIndustryIdValueChange"
            />
          </el-form-item>
        </el-col>
<!--        <el-col :span="24">-->
<!--          <el-form-item label="产业" prop="SpecialistMember.industryName">-->
<!--            <el-input class="input-item" v-model="formData.SpecialistMember.industryName"-->
<!--              :clearable="true" placeholder="产业"-->
<!--            />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="24">
          <el-form-item label="职称" prop="SpecialistMember.specialistTitleId">
            <el-select class="input-item" v-model="formData.SpecialistMember.specialistTitleId" :clearable="true" filterable
              placeholder="职称" :loading="specialistMemberEdit.specialistTitleId.impl.loading"
              @visible-change="specialistMemberEdit.specialistTitleId.impl.onVisibleChange"
              @change="onSpecialistTitleIdValueChange">
              <el-option v-for="item in specialistMemberEdit.specialistTitleId.impl.dropdownList" :key="item.id"
                :value="item.id" :label="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
<!--        <el-col :span="24">-->
<!--          <el-form-item label="职称" prop="SpecialistMember.specialistTitle">-->
<!--            <el-input class="input-item" v-model="formData.SpecialistMember.specialistTitle"-->
<!--              :clearable="true" placeholder="职称"-->
<!--            />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistMemberController, DictionaryController } from '@/api';

export default {
  name: 'specialistMemberEdit',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    },
    specialistMemberForm: []
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SpecialistMember: {
          id: undefined,
          createTime: undefined,
          specialistId: undefined,
          specialistName: undefined,
          specialistAvatar: undefined,
          gender: undefined,
          mobilePhone: undefined,
          industryId: undefined,
          industryName: undefined,
          specialistTitle: undefined,
          specialistTitleId: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'SpecialistMember.specialistName': [
          {required: true, message: '请输入专家名称', trigger: 'change'}
        ],
        'SpecialistMember.mobilePhone': [
          {required: true, message: '请输入联系电话', trigger: 'change'}
        ],
        'SpecialistMember.industryId': [
          {required: true, message: '请选择产业', trigger: 'change'}
        ],
        'SpecialistMember.specialistTitleId': [
          {required: true, message: '请选择职称', trigger: 'change'}
        ]
      },
      specialistMemberEdit: {
        formFilter: {
        },
        formFilterCopy: {
        },
        specialistAvatar: {
          impl: new UploadWidget(1)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 产业ID下拉数据获取函数
     */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 产业ID选中值改变
     */
    onIndustryIdValueChange (value) {
      const checkedNode = this.$refs['cascaderArr'].getCheckedNodes();
      this.formData.SpecialistMember.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;

      this.formData.SpecialistMember.industryName = checkedNode[0].data.name
    },
    /**
     * 职称ID下拉数据获取函数
     */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职称ID选中值改变
     */
    onSpecialistTitleIdValueChange (value) {
      console.log('value', value)
      var name = '';
      this.specialistMemberEdit.specialistTitleId.impl.dropdownList.forEach(function (item, index) {
        if (value === item.id) {
          name = item.name;
        }
      });
      this.formData.SpecialistMember.specialistTitle = name
    },
    /**
     * 更新团队成员编辑
     */
    refreshSpecialistMemberEdit (reloadData = false) {
      this.loadSpecialistMemberDetailData().then(res => {
        if (!this.specialistMemberEdit.isInit) {
          // 初始化下拉数据
          this.specialistMemberEdit.industryId.impl.onVisibleChange(true).then(res => {
            this.specialistMemberEdit.industryId.value = findTreeNodePath(res, this.formData.SpecialistMember.industryId, 'id');
          }).catch(e => {});
          this.specialistMemberEdit.specialistTitleId.impl.onVisibleChange(true).then(res => {
            this.specialistMemberEdit.specialistTitleId.value = findTreeNodePath(res, this.formData.SpecialistMember.specialistTitleId, 'id');
          }).catch(e => {});
        }
        this.specialistMemberEdit.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.specialistMemberEdit.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            industryIdDictMap: findItemFromList(this.specialistMemberEdit.industryId.impl.dropdownList, this.formData.SpecialistMember.industryId, 'id'),
            specialistTitleIdDictMap: findItemFromList(this.specialistMemberEdit.specialistTitleId.impl.dropdownList, this.formData.SpecialistMember.specialistTitleId, 'id'),
            ...this.formData.SpecialistMember
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          specialistMemberDto: {
            id: this.formData.SpecialistMember.id,
            specialistId: this.formData.SpecialistMember.specialistId,
            specialistName: this.formData.SpecialistMember.specialistName,
            specialistAvatar: this.formData.SpecialistMember.specialistAvatar,
            mobilePhone: this.formData.SpecialistMember.mobilePhone,
            industryId: this.formData.SpecialistMember.industryId,
            industryName: this.formData.SpecialistMember.industryName,
            specialistTitle: this.formData.SpecialistMember.specialistTitle,
            specialistTitleId: this.formData.SpecialistMember.specialistTitleId
          }
        };
        this.$message.success('保存成功');
        this.onCancel(true, params);
        //
        // SpecialistMemberController.update(this, params).then(res => {
        //   this.$message.success('保存成功');
        //   this.onCancel(true);
        // }).catch(e => {});
      });
    },

    /**
     * 获取表详细信息
     */
    loadSpecialistMemberDetailData () {
      return new Promise((resolve, reject) => {
        console.log('this.budgetDetailForm修改', this.specialistMemberEdit)
        if (!this.formData.SpecialistMember.isDatasourceInit) {
          if (
            this.specialistMemberForm == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          this.formData.SpecialistMember = this.specialistMemberForm;
          if (this.formData.SpecialistMember.industryIdDictMap && this.specialistMemberEdit.industryId.impl.dirty) {
            this.specialistMemberEdit.industryId.impl.dropdownList = [this.formData.SpecialistMember.industryIdDictMap];
          }
          if (this.formData.SpecialistMember.industryId) this.specialistMemberEdit.industryId.value = [this.formData.SpecialistMember.industryId];
          if (this.formData.SpecialistMember.specialistTitleIdDictMap && this.specialistMemberEdit.specialistTitleId.impl.dirty) {
            this.specialistMemberEdit.specialistTitleId.impl.dropdownList = [this.formData.SpecialistMember.specialistTitleIdDictMap];
          }
          if (this.formData.SpecialistMember.specialistTitleId) this.specialistMemberEdit.specialistTitleId.value = [this.formData.SpecialistMember.specialistTitleId];

          let specialistAvatarDownloadParams = {
            id: this.formData.SpecialistMember.id,
            fieldName: 'specialistAvatar',
            asImage: true
          }
          this.specialistMemberEdit.specialistAvatar.impl.fileList = this.parseUploadData(this.formData.SpecialistMember.specialistAvatar, specialistAvatarDownloadParams);
          resolve();

          // BudgetDetailController.view(this, params).then(res => {
          //   this.formData.BudgetDetail = {...res.data, isDatasourceInit: true};
          //   if (this.formData.BudgetDetail.productIdDictMap && this.budgetDetailEdit.productId.impl.dirty) {
          //     this.budgetDetailEdit.productId.impl.dropdownList = [this.formData.BudgetDetail.productIdDictMap];
          //   }
          //   if (this.formData.BudgetDetail.productId) this.budgetDetailEdit.productId.value = [this.formData.BudgetDetail.productId];
          //   resolve();
          // }).catch(e => {
          //   reject();
          // });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 专家照片上传成功
     */
    onSpecialistAvatarUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.specialistMemberEdit.specialistAvatar.impl.onFileChange(file, fileList);
        this.formData.SpecialistMember.specialistAvatar = this.fileListToJson(this.specialistMemberEdit.specialistAvatar.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除专家照片
     */
    onSpecialistAvatarRemoveFile (file, fileList) {
      this.specialistMemberEdit.specialistAvatar.impl.onFileChange(file, fileList);
      this.formData.SpecialistMember.specialistAvatar = this.fileListToJson(this.specialistMemberEdit.specialistAvatar.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SpecialistMember: {
          id: undefined,
          createTime: undefined,
          specialistId: undefined,
          specialistName: undefined,
          specialistAvatar: undefined,
          gender: undefined,
          mobilePhone: undefined,
          industryId: undefined,
          industryName: undefined,
          specialistTitle: undefined,
          specialistTitleId: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshSpecialistMemberEdit();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SpecialistMember = {
        ...this.rowData
      }
      let specialistAvatarDownloadParams = {
        id: this.formData.SpecialistMember.id,
        fieldName: 'specialistAvatar',
        asImage: true
      }
      this.specialistMemberEdit.specialistAvatar.impl.fileList = this.parseUploadData(this.formData.SpecialistMember.specialistAvatar, specialistAvatarDownloadParams);
      if (this.formData.SpecialistMember.industryIdDictMap && this.specialistMemberEdit.industryId.impl.dirty) {
        this.specialistMemberEdit.industryId.impl.dropdownList = [this.formData.SpecialistMember.industryIdDictMap];
      }
      if (this.formData.SpecialistMember.specialistTitleIdDictMap && this.specialistMemberEdit.specialistTitleId.impl.dirty) {
        this.specialistMemberEdit.specialistTitleId.impl.dropdownList = [this.formData.SpecialistMember.specialistTitleIdDictMap];
      }
    }
  },
  watch: {
  }
}
</script>
